// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"188":"21576ca6","453":"d855a71b"}[chunkId] + ".chunk.js";
};